import { getIntlayer, getLocaleFromStorageClient } from 'intlayer'
import { defaultLocale } from '@/features/i18n/domain/locale'
import type { MessageKey, MessageParams, MessagesPort } from '../domain/message'

const intlayerMessages: MessagesPort = {
	resolve: (key: MessageKey, params?: MessageParams) => {
		const locale = getLocaleFromStorageClient() ?? defaultLocale
		const dictionary = getIntlayer('messages', locale)
		const value = dictionary[key]
		if (typeof value === 'function') return value(params as { name: string | number })
		return value
	},
}

export { intlayerMessages }
